// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// Export the factory function instead of a class to prevent initialization order problems

// Export types
export type FetchSiteTextsParams = {
	locale?: string;
	scopes?: string[];
	textKeys?: string[];
};

export type SiteTextDto = {
	uid: string;
	text_key: string;
	scope: string;
	locale: string;
	content: string;
	description: string | null;
	is_html: boolean;
	version: number;
	publication_status: string;
	updated_at: string | null;
};

export type FetchSiteTextsResponse = {
	locale: string;
	count: number;
	texts: SiteTextDto[];
};

// Export a compatible interface for backwards compatibility
export interface ISiteTexts {
	fetchPublished(params?: FetchSiteTextsParams): Promise<FetchSiteTextsResponse>;
}

import { getLazyFactoryGetter } from "@Front/Api/helpers/dynamicFactoryLoader";

function getFactory(): () => ISiteTexts {
	return getLazyFactoryGetter("LeCoffreApi/Public/SiteTexts") as () => ISiteTexts;
}

// Export the instance getter as the main export
export const SiteTextsApi = {
	getInstance: (): ISiteTexts => {
		return getFactory()();
	},
};

// Export default for backward compatibility with existing imports
export default SiteTextsApi;
